module.exports = __webpack_public_path__ + "static/img/user.f019179.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/user.png
// module id = H6hj
// module chunks = 0